import Swal from "sweetalert2";
import axios from "../../axios";
import { ADD_CATEGORY, DELETE_CATEGORY, GET_CATEGORIES, UPDATE_CATEGORY } from "../types";
import { setAlert } from "./alert";
import { getErrorMessage } from "../../helpers/ErrorMessage";

export const getCategories = () => async (dispatch) => {
  try {
    const res = await axios.get("category/all");
    if (res.data.code === 1) {
      dispatch({ type: GET_CATEGORIES, payload: res.data.data });
    }
  } catch (err) {
    console.log("err :", err);
    // dispatch(setAlert(err.message, "danger"));
    // // Use the global error message function
    // const errorMessage = getErrorMessage(err.response?.data);

    // Swal.fire({
    //     title: 'Error!',
    //     text: errorMessage,
    //     icon: 'error',
    // });
  }
};
export const addCategory = (data, isFormData = false) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

    const res = await axios.post("category/add", data, config);

    if (res.data.code === 1) {
      dispatch({ type: ADD_CATEGORY, payload: res.data.data });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
    }
  } catch (err) {
    const errMsg = err?.response?.data?.message || err.message || "Something went wrong";
    dispatch(setAlert(errMsg, "danger"));
    Swal.fire({ title: "Error!", text: errMsg, icon: "error" });
  }
};

export const updateCategory = (data, isFormData = false) => async (dispatch) => {
  try {
    const config = {
      headers: {
        "Content-Type": isFormData ? "multipart/form-data" : "application/json",
      },
    };

    const res = await axios.post("category/update", data, config);

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_CATEGORY, payload: res.data.data });
      Swal.fire({ title: "Success!", text: res.data.message, icon: "success" });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({ title: "Warning!", text: res.data.message, icon: "warning" });
    }
  } catch (err) {
    const errMsg = err?.response?.data?.message || err.message || "Something went wrong";
    dispatch(setAlert(errMsg, "danger"));
    Swal.fire({ title: "Error!", text: errMsg, icon: "error" });
  }
};

export const updateCategoryStatus = (id, status) => async (dispatch) => {
  try {
    // const updatedFormData = { ...formData, id: formData._id };
    // console.log("formdata updateCustomerStatus:", id, status);

    const res = await axios.post(
      "category/update",
      { id, status },
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    if (res.data.code === 1) {
      dispatch({ type: UPDATE_CATEGORY, payload: res.data.data });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
      Swal.fire({
        title: "Warning!",
        text: res.data.message,
        icon: "warning",
      });
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: 'Error!',
      text: errorMessage,
      icon: 'error',
    });
  }
};

export const deleteCategory = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert("Please select any record", "warning"));
      return false;
    }
    const res = await axios.post(`category/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_CATEGORY, payload: { id } });
      Swal.fire({
        title: "Success!",
        text: res.data.message,
        icon: "success",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
    if (res.data.code === 0) {
      Swal.fire({
        title: "Error!",
        text: res.data.message || "An unexpected error occurred",
        icon: "error",
      });
      dispatch(setAlert(res.data.message, "success"));
    } else {
      dispatch(setAlert(res.data.message, "warning"));
    }
  } catch (err) {
    dispatch(setAlert(err.message, "danger"));
    // Use the global error message function
    const errorMessage = getErrorMessage(err.response?.data);

    Swal.fire({
      title: "Error!",
      text: errorMessage,
      icon: "error",
    });
  }
};
